import { render } from "./AttrMenu.vue?vue&type=template&id=9dc6ebf2"
import script from "./AttrMenu.vue?vue&type=script&lang=js"
export * from "./AttrMenu.vue?vue&type=script&lang=js"

import "./AttrMenu.vue?vue&type=style&index=0&id=9dc6ebf2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9dc6ebf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9dc6ebf2', __exports__)) {
    api.reload('9dc6ebf2', __exports__)
  }
  
  module.hot.accept("./AttrMenu.vue?vue&type=template&id=9dc6ebf2", () => {
    api.rerender('9dc6ebf2', render)
  })

}


export default __exports__